import { render, staticRenderFns } from "./AdminAllQuotes.vue?vue&type=template&id=dc01393a"
import script from "./AdminAllQuotes.vue?vue&type=script&lang=js"
export * from "./AdminAllQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports